import React, { useEffect, useState } from "react";
import { FlowService } from "../../../service/FlowService";
import { Box, Typography, useTheme } from "@mui/material";
import {
  NotificationType,
  useNotificationStore,
} from "../../../store/storeNotifications";
import { getAPIErrorMessage } from "../../../helpers/helpers";
import LoadingSpinner from "../../../components/UI/LoadingSpinner";
import FlowsTable from "../../Dashboard/FlowsTable";

const SharedFiles: React.FC = () => {
  const setNotification = useNotificationStore(
    (state) => state.setNotification,
  );
  const [sharedFlows, setSharedFlows] = useState<any[]>([]);
  const [page, setPage] = useState(1);

  const [loading, setLoading] = useState(true);
  const theme = useTheme();
  const { semanticColors } = theme;

  useEffect(() => {
    const getSharedFlows = async () => {
      try {
        const { data } = await FlowService.getSharedFlows(page);
        setSharedFlows(data[0]);
      } catch (error) {
        setNotification({
          type: NotificationType.Error,
          message: getAPIErrorMessage(error as any),
        });
      }
      setLoading(false);
    };

    getSharedFlows();
  }, [page, setNotification]);

  if (loading) return <LoadingSpinner />;

  if (!loading && sharedFlows.length === 0)
    return (
      <Box
        sx={{
          border: `1px dashed ${semanticColors.borderDashed}`,
          width: "calc(100% - 2px)",
          height: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Typography
          sx={{
            color: semanticColors.textSecondary,
          }}
        >
          You don't have any shared agents
        </Typography>
      </Box>
    );

  return (
    <Box sx={{ height: "100%", width: "100%" }}>
      <FlowsTable flows={sharedFlows} />
    </Box>
  );
};

export default SharedFiles;
